import React from "react";

// Local image from uploaded assets (tool will transform path to a URL)
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

export default function FooterCard9() {
  return (
    <footer className="vw-footer">
      <div className="newsletter-fc-9">
        <div className="newsletter-fc-9-inner">
          <div className="newsletter-fc-9-left">
            <h4 className="small">Newsletter</h4>
            <h2>Subscribe Our Newsletter !</h2>
          </div>

          <div className="newsletter-fc-9-right">
            <input className="email-fc-9" placeholder="Enter E-mail here" />
            <button className="btn-fc-9">Subscribe Now</button>
          </div>
        </div>
      </div>

      <div className="footer-top-outer">
      <div className="footer-top">
        <div className="col-fc-9 about">
          <h2>Vision Classes</h2>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s.
          </p>
          <div className="socials-fc-9">
            <span className="pill-fc-9"> <FaFacebookF />
                       </span>
            <span className="pill-fc-9"> <FaTwitter />
                       </span>
            <span className="pill-fc-9"> <FaInstagram />
                       </span>
            <span className="pill-fc-9"> <FaLinkedinIn />
                       </span>
          </div>
        </div>

        <div className="col-fc-9 links-fc-9">
          <h4>Quick Links</h4>
          <ul>
            <li>Data Science</li>
            <li>Web Development</li>
            <li>UI/UX Design</li>
            <li>Health / Fitness</li>
            <li>Business</li>
          </ul>
        </div>

        <div className="col-fc-9 courses">
          <h4>Courses</h4>
          <ul>
            <li>About Us</li>
            <li>Courses</li>
            <li>Blog</li>
            <li>Events</li>
            <li>Contact</li>
          </ul>
        </div>

        <div className="col-fc-9 contact">
          <h4>Contact Info</h4>
          <p>📍 Lorem Ipsum is simply dummy</p>
          <p>📞 +12 3456789012</p>
          <p>✉️ education123@example.com</p>
          <p>🕒 Monday To Saturday 09.00AM To 05.00PM</p>
          <button className="btn-fc-9 outline">Buy Now</button>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} VW Institute - All Rights Reserved.</p>
        <nav>
          <a>Home</a>
          <a>About Us</a>
          <a>Services</a>
          <a>Contact Us</a>
        </nav>
      </div>
      </div>

      <style>{`
        .vw-footer{font-family: Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial; color:#222}
        .newsletter-fc-9{background:rgba(144, 202, 249,1);padding:36px 0;border-radius:14px;margin:48px 6%;}
        .newsletter-fc-9-inner{display:flex;align-items:center;justify-content:space-between;gap:20px;max-width:1200px;margin:0 auto;padding:0 20px}
        .newsletter-fc-9-left .small{color:rgba(255,255,255,0.85);margin:0;font-size:13px;font-weight:600}
        .newsletter-fc-9-left h2{margin:6px 0 0;color:#fff;font-size:28px}
        .newsletter-fc-9-right{display:flex;gap:12px;align-items:center}
        .newsletter-fc-9 .email-fc-9{padding:12px 16px;border-radius:6px;border:none;min-width:360px}
        .newsletter-fc-9 .btn-fc-9{background:#ffffff;border:1px solid rgba(144, 202, 249,1);color:rgba(144, 202, 249,1);border:none;padding:12px 18px;border-radius:8px;cursor:pointer}

        .footer-top-outer{background:linear-gradient(135deg,rgba(144, 202, 249,0.11) 0%, #f3e8ff 100%);border-radius:16px}
        .footer-top{display:flex;gap:40px;max-width:1200px;margin:48px auto;padding:40px 20px;}
        .footer-top .col-fc-9{flex:1;min-width:180px}
        .about .logo-fc-9{width:90px;height:auto;margin-bottom:12px;border-radius:8px}
        .about p{color:#444;line-height:1.6}
        .socials-fc-9{margin-top:16px;display:flex;gap:8px}
        .pill-fc-9{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:8px;background:#111;color:#fff}

        .links-fc-9 h4,.courses h4,.contact h4{font-size:18px;margin-bottom:12px;color:#111}
        .links-fc-9 ul,.courses ul{list-style:none;padding:0;margin:0}
        .links-fc-9 li,.courses li{margin:8px 0;color:#333}

        .contact p{margin:8px 0;color:#333}
        .btn-fc-9.outline{background:transparent;border:2px solid rgba(144, 202, 249,1);color:rgba(144, 202, 249,1);padding:10px 14px;border-radius:8px;margin-top:12px}

        .footer-bottom{display:flex;justify-content:space-between;align-items:center;max-width:1200px;margin:24px auto;padding:18px 20px;border-top:1px solid rgba(0,0,0,0.06)}
        .footer-bottom p{color:#666;margin:0}
        .footer-bottom nav a{margin-left:18px;color:#333;text-decoration:none}

        /* responsive */
        @media (max-width:900px){
          .newsletter-fc-9-inner{flex-direction:col-fc-9umn;align-items:flex-start}
          .newsletter-fc-9-right{width:100%;justify-content:stretch}
          .newsletter-fc-9 .email-fc-9{min-width:100%}
          .footer-top{flex-direction:col-fc-9umn}
          .footer-bottom{flex-direction:col-fc-9umn;gap:12px}
        }
      `}</style>
    </footer>
  );
}
